export default "__VITE_IMAGE_ASSET__341306a2__";